<template>
  <section id="visitingDetail" class="pt-2">
    <v-snackbar :timeout="5000" :value="message.show" absolute top :color="message.type">
      <v-alert :type="message.type" class="mb-0"> {{ message.text }} </v-alert>
      <template v-slot:action="{ attrs }">
        <v-btn color="white" text v-bind="attrs" @click="message.show = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </template>
    </v-snackbar>
    <v-row class="ma-0 px-2">
      <v-spacer></v-spacer>
      <v-btn v-if="user.role?.includes('RRS')" tile outlined class="error white--text" @click="dialog = true">删除</v-btn>
      <v-btn v-if="visitId" tile outlined class="primary white--text ml-2" @click="openComment">评论</v-btn>
      <v-btn tile outlined 
        v-if="(user.role?.includes('Sales') || user.role?.includes('Sell-in Sales') || user.role?.includes('External Sales')) && ((user?.userId === visit?.salesId) ||!visitId)" 
        class="warning white--text ml-2"
        @click="newSave()">保存</v-btn>
      <v-btn tile outlined
        v-if="(user.role?.includes('Sales') || user.role?.includes('Sell-in Sales') || user.role?.includes('External Sales')) && ((user?.userId === visit?.salesId) ||!visitId)"
        class="success white--text ml-2"
        @click="newSubmit()">提交</v-btn>
    </v-row>
    <div id="detailForm">
      <v-form class="px-4 mb-15" ref="form" v-model="valid" lazy-validation
        :readonly="!(user.role?.includes('Sales') || user.role?.includes('Sell-in Sales') || user.role?.includes('External Sales'))">
        <p class="subtitle-1 font-weight-bold">{{ currentDate }}</p>
        <!-- <v-combobox outlined dense label="客户类型" :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
          v-model="visit.dealerType" item-value="name" :return-object="false" :items="dealerTypeList" item-text="name"
          :rules="[(v) => !!v || '这是必填项']"></v-combobox> -->

        <v-autocomplete outlined dense label="拜访类型及对象"
                        :rules="[(v) => !!v || '这是必填项']"
                        :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales') || user.role?.includes('External Sales')" v-model="visit.visitType"
                        item-value="name" small-chips required :return-object="false" :items="visitTypeList" item-text="name"
        ></v-autocomplete>

        <v-combobox outlined dense label="客户名称" :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales') || user.role?.includes('External Sales')"
          v-model="visit.dealerName" item-value="name" :return-object="false" :items="dealers" item-text="name"
          @change="dealerNameChangeNew" :rules="[(v) => !!v || '这是必填项']"></v-combobox>

        <v-textarea :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales') || user.role?.includes('External Sales')" outlined dense label="客户联系人"
          height="60" v-model="visit.dealerContacts"></v-textarea>
        <v-textarea :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales') || user.role?.includes('External Sales')" outlined dense label="客户联系方式"
                    height="60" v-model="visit.customerContactInfo"
                    :rules="[(v) => {  
                                if (typeof v !== 'string' || !/^\d{11}$/.test(v)) {  
                                  return '手机号必须为11位数字';  
                                }  
                                return true;  
                              }  
                            ]"
        ></v-textarea>
        <!-- <v-textarea :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" outlined dense label="职位"
          height="60" v-model="visit.dealerPosition"></v-textarea> -->
        <v-autocomplete outlined dense label="职位" :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales') || user.role?.includes('External Sales')"
          v-model="visit.dealerPosition" small-chips required :return-object="false" :items="dealerPositionList"
          item-text="name" item-value="name"></v-autocomplete>

        <!-- <v-autocomplete outlined dense label="本次拜访主要沟通渠道"
          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" v-model="visit.visitConnectShow"
          item-value="name" multiple small-chips required :return-object="false" :items="visitConnectList"
          item-text="name"></v-autocomplete> -->
<!--        <v-autocomplete outlined dense label="本次拜访主要沟通渠道1"-->
<!--          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" v-model="visit.visitConnect1"-->
<!--          item-value="name" small-chips required :return-object="false" :items="visitConnectList" item-text="name"-->
<!--          @change="connect1Change"></v-autocomplete>-->
        
        <!--当选择的是装修公司的时候填写装修公司名称1-->
<!--        <v-textarea v-if="this.visit.visitConnect1 == '装饰公司'"-->
<!--          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" outlined dense label="装修公司名称1" height="60"-->
<!--          v-model="visit.decorationCompany1"></v-textarea>-->

<!--        <v-autocomplete outlined dense label="建立合作机率1" v-if="this.visit.visitConnect1 != '其他事项'"-->
<!--          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" v-model="visit.cooperateProbability1"-->
<!--          item-value="name" :return-object="false" :items="cooperateProbabilityList" item-text="name"></v-autocomplete>-->
        <!--当选择的不是竞品客户拜访的时候显示-->
<!--        <v-text-field v-if="this.visit.visitConnect1 != '其他事项' && this.visit.visitConnect1!='竞品客户'" outlined-->
<!--          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" dense label="此渠道预计全年博世壁挂炉采购潜力(台)1"-->
<!--          v-model="visit.ovenSaleCapacity1" height="60" type="number"></v-text-field>-->
        <!--当选择的是竞品客户拜访的时候显示-->
<!--        <v-text-field v-if="this.visit.visitConnect1 != '其他事项' && this.visit.visitConnect1=='竞品客户'" outlined-->
<!--          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" dense label="此渠道预计全年壁挂炉采购潜力(台)1"-->
<!--          v-model="visit.ovenSaleCapacity1" height="60" type="number"></v-text-field>-->


        <!--添加拜访渠道-->
<!--        <div class="text-center" style="margin-bottom: 20px;" v-if="this.showVisitConnect == 0">-->
<!--          <v-btn block color="#ffffff" @click="changConnect">-->
<!--            添加拜访渠道<v-icon right>mdi-plus-circle-outline</v-icon>-->
<!--          </v-btn>-->
<!--        </div>-->
<!--        <div class="text-center" style="margin-bottom: 20px;" v-if="this.showVisitConnect == 1">-->
<!--          <v-btn block color="#ffffff" @click="changConnect">-->
<!--            删除拜访渠道<v-icon right>mdi-minus-circle-outline</v-icon>-->
<!--          </v-btn>-->
<!--        </div>-->
<!--        <div style="background-color: #eee;">-->
<!--          <v-autocomplete outlined dense label="本次拜访主要沟通渠道2" v-if="this.showVisitConnect == 1"-->
<!--            :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" v-model="visit.visitConnect2"-->
<!--            item-value="name" small-chips required :return-object="false" :items="visitConnectList" item-text="name"-->
<!--            @change="connect2Change"></v-autocomplete>-->
<!--          &lt;!&ndash;当选择的是装修公司的时候填写装修公司名称2&ndash;&gt;-->
<!--          <v-textarea v-if="this.visit.visitConnect2 == '装饰公司' && this.showVisitConnect == 1"-->
<!--            :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" outlined dense label="装修公司名称2" height="60"-->
<!--            v-model="visit.decorationCompany2"></v-textarea>-->
<!--          <v-autocomplete outlined dense label="建立合作机率2"-->
<!--            v-if="this.showVisitConnect == 1 && this.visit.visitConnect2 != '其他事项'"-->
<!--            :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" v-model="visit.cooperateProbability2"-->
<!--            item-value="name" :return-object="false" :items="cooperateProbabilityList" item-text="name"></v-autocomplete>-->
<!--          &lt;!&ndash;当选择的不是竞品客户拜访的时候显示&ndash;&gt;-->
<!--          <v-text-field outlined :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" dense-->
<!--            label="此渠道预计全年博世壁挂炉采购潜力(台)2" v-if="this.showVisitConnect == 1 && this.visit.visitConnect2 != '其他事项' && this.visit.visitConnect2!='竞品客户'"-->
<!--            v-model="visit.ovenSaleCapacity2" height="60" type="number"></v-text-field>-->
<!--          &lt;!&ndash;当选择的是竞品客户拜访的时候显示&ndash;&gt;-->
<!--          <v-text-field outlined :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" dense-->
<!--            label="此渠道预计全年壁挂炉采购潜力(台)2" v-if="this.showVisitConnect == 1 && this.visit.visitConnect2 != '其他事项' && this.visit.visitConnect2=='竞品客户'"-->
<!--            v-model="visit.ovenSaleCapacity2" height="60" type="number"></v-text-field>-->
<!--        </div>-->

        <!-- <p class="subtitle-1 font-weight-bold">拜访信息</p> -->
<!--        <v-textarea :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" outlined dense label="拜访目的"-->
<!--          height="60" v-model="visit.goal"></v-textarea>-->
        <v-textarea :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales') || user.role?.includes('External Sales')" outlined dense label="拜访内容（主要交流内容及市场情况反馈）"
                    height="60" v-model="visit.visitContent"></v-textarea>
<!--        <v-textarea outlined :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" dense label="拜访结果"-->
<!--          v-model="visit.resultPlusPlan" height="60"></v-textarea>-->
        <v-textarea outlined :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales') || user.role?.includes('External Sales')" dense label="竞品信息反馈"
                    v-model="visit.competitiveProductInfoFeedback" height="60"></v-textarea>
<!--        <v-textarea outlined :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" dense label="待处理问题"-->
<!--          v-model="visit.questionPoint" height="60"></v-textarea>-->
        <v-textarea outlined :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales') || user.role?.includes('External Sales')" dense label="备注"
          v-model="visit.remark" height="60"></v-textarea>
        <!-- 拜访渠道仅为其他事项的时候不显示 -->
<!--        <v-text-field-->
<!--          v-if="(this.visit.visitConnect1 && this.visit.visitConnect1 != '其他事项'&&this.visit.visitConnect1!='竞品客户') || (this.visit.visitConnect2 && this.visit.visitConnect2 != '其他事项'&&this.visit.visitConnect2!='竞品客户') || (!this.visit.visitConnect2 && !this.visit.visitConnect1&&this.visit.visitConnect1!='竞品客户'&&this.visit.visitConnect2!='竞品客户')"-->
<!--          outlined :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" dense-->
<!--          @input="checkDealerVolumeOnInput" label="客户上个月博世壁挂炉签约总台数(台)" v-model="visit.dealerVolume" height="60"-->
<!--          type="number"></v-text-field>-->
        <!--   仅“拜访类型及对象”选竞品/潜在零售商时需要填写,潜在客户壁挂炉销售潜力（台/年）字段，其他拜访类型时不显示     -->
        <v-text-field
            v-if="(this.visit.visitType == '竞品/潜在零售商')"
            :rules="[(v) => !!v || '这是必填项']"
            outlined :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales') || user.role?.includes('External Sales')" dense
            @input="checkPotentialSalesPotentialOnInput" label="潜在客户壁挂炉销售潜力（台/年）" v-model="visit.potentialSalesPotential" height="60"
            type="number"></v-text-field>
<!--        <v-text-field-->
<!--          v-if="(this.visit.visitConnect1 && this.visit.visitConnect1 != '其他事项'&&this.visit.visitConnect1!='竞品客户') || (this.visit.visitConnect2 && this.visit.visitConnect2 != '其他事项'&&this.visit.visitConnect2!='竞品客户') || (!this.visit.visitConnect2 && !this.visit.visitConnect1&&this.visit.visitConnect1!='竞品客户'&&this.visit.visitConnect2!='竞品客户')"-->
<!--          outlined :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" dense @input="onInput"-->
<!--          label="近两个月全渠道客流量同比(%)" v-model="visit.dealerYoy" height="60" type="number"></v-text-field>-->

        <!-- <p class="subtitle-1 font-weight-bold">本次拜访主要渠道</p> -->
        <!-- <v-autocomplete outlined dense label="建立合作机率" :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
          v-model="visit.cooperateProbability" item-value="name" :return-object="false" :items="cooperateProbabilityList"
          item-text="name"></v-autocomplete>
        <v-text-field outlined :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" dense
          label="全年(12个月)所有品牌壁挂炉采购潜力(台)" v-model="visitData.ovenSaleCapacity" height="60" type="number"></v-text-field> -->
        <!-- <v-text-field outlined :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" dense
          label="博世壁挂炉钱包份额SoW/%" v-model="visitData.sowShowValue" height="60" type="number"></v-text-field>
        <v-text-field outlined :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" dense :disabled="true"
          label="预计当年博世壁挂炉采购潜力(台)" v-model="visit_boschOvenSaleCapacityCompute" height="60"></v-text-field> -->
        <!-- <p class="subtitle-1 font-weight-bold">产品推进情况</p>
        <v-textarea
          outlined
          :rules="[(v) => !!v || '这是必填项']"
          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
          dense
          label="新风&水箱"
          v-model="visit.ventilationState"
          height="60"
        ></v-textarea>
        <v-textarea
          outlined
          :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
          dense
          :rules="[(v) => !!v || '这是必填项']"
          label="热泵"
          v-model="visit.hotPumpState"
          height="60"
        ></v-textarea>
        <v-textarea
            outlined
            :rules="[(v) => !!v || '这是必填项']"
            :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"
            dense
            label="亮点"
            v-model="visit.highlight"          
            height="60"
          ></v-textarea>
      -->
<!--        <div v-if="isDealerShow">-->
<!--          <p class="subtitle-1 font-weight-bold">客户信息管理</p>-->
<!--          <v-autocomplete outlined dense label="客户类型" item-value="id" item-text="name" multiple small-chips-->
<!--            v-model="dealer.majorSaleChannelIdsShow" :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')"-->
<!--            :items="dealerTypeList" required @change="handleSelectChange"></v-autocomplete>-->
<!--          &lt;!&ndash; :rules="[-->
<!--            (v) => v?.length <= 3 || '最多选择三个！',-->
<!--          ]" &ndash;&gt;-->
<!--          <v-autocomplete outlined dense label="客户建立合作机率" item-value="id" item-text="name"-->
<!--            :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" :items="hzzt" required-->
<!--            v-model="dealer.developmentStateId"></v-autocomplete>-->
<!--          <v-text-field outlined :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" dense-->
<!--            label="全年(12个月)所有品牌壁挂炉采购潜力(台)" v-model="dealerData.ovenSaleCapacity" height="60" type="number"></v-text-field>-->
<!--          <v-text-field outlined :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" dense-->
<!--            @input="checkDealerSowShowValueOnInput" label="博世壁挂炉钱包份额SoW/%" v-model="dealerData.sowShowValue" height="60"-->
<!--            type="number"></v-text-field>-->
<!--          <v-text-field outlined :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales')" dense :disabled="true"-->
<!--            label="预计当年博世壁挂炉采购潜力(台)" v-model="boschOvenSaleCapacityCompute" height="60"></v-text-field>-->
<!--        </div>-->
      </v-form>
    </div>
    <v-dialog v-model="dialog" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">提示</span>
        </v-card-title>
        <v-card-text>
          <span>确认删除吗？</span>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="dialog = false">
            关闭
          </v-btn>
          <v-btn color="blue darken-1" text @click="onDeleteVisit()">
            确认
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay :value="loading">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <v-dialog v-model="comment" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">评论记录</span>
        </v-card-title>
        <v-card-text class="pb-0 px-2">
          <div class="commentContainer">
            <v-timeline dense v-if="commentList.length">
              <v-timeline-item small v-for="(item, index) in commentList" :key="index">
                <v-card class="mr-1">
                  <v-card-subtitle class="py-1 px-2 font-weight-black">{{
                    `${item.createTime} ${item.createBy || ""}`
                  }}</v-card-subtitle>
                  <v-card-text class="py-1 px-2">{{
                    item.feedBackText
                  }}</v-card-text>
                </v-card>
              </v-timeline-item>
            </v-timeline>
          </div>
          <v-textarea outlined :clearable="user.role?.includes('Sales') || user.role?.includes('Sell-in Sales') || user.role?.includes('External Sales')" hide-details dense
            height="80" label="评论" v-model="newComment"></v-textarea>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="comment = false">
            关闭
          </v-btn>
          <v-btn color="blue darken-1" text :disabled="!newComment" @click="saveComment()">
            保存
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <!---保存确认--->
    <v-dialog v-model="dialog2" persistent>
      <v-card>
        <v-card-title>
          <span class="text-h5">提示</span>
        </v-card-title>
        <v-card-text>
          <!-- <span>客户建立合作机率已大于30%，请至客户管理里补全此客户其它必要信息</span> -->
          <span>客户建立合作机率已等于100%，请至客户管理里补全此客户其它必要信息</span>
          <!-- <span>以下信息不完整，请补充完整再提交</span> -->
          <p></p>
          <!-- <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*全年(12个月)所有品牌壁挂炉采购潜力(台)</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*博世壁挂炉钱包份额SoW/%</p>
          <p>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;*预计当年博世壁挂炉采购潜力(台)</p> -->
          <p></p>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="red darken-1" text @click="clickCancle()">
            转到客户管理
          </v-btn>
          <!-- <v-btn color="blue darken-1" text @click="clickOk()">
            保存
          </v-btn> -->
          <!-- <v-btn color="blue darken-1" text @click="clickConfirm()">
            取消提交
          </v-btn> -->
          <!-- <v-btn color="green darken-1" v-if="isSubmit" text @click="clickSubmit()">
            确认提交
          </v-btn>
          <v-btn color="green darken-1" v-if="!isSubmit" text @click="clickSubmit()">
            确认保存
          </v-btn> -->
          <v-btn color="green darken-1" text @click="clickSubmit()">
            先保存拜访记录
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </section>
</template>

<script>
import api from "../../api/api";
import moment from "moment";
import { mapState } from "vuex";
export default {
  name: "VisitingDetail",
  computed: {
    ...mapState(["category", "user"]),
    currentDate() {
      return moment(
        this.visit.visitDate
          ? this.visit.visitDate
          : this.$route.query.date || new Date()
      ).format("yyyy-MM-DD");
    },
    isDealerShow: {
      get: function () {
        let dealerFlag = true
        let dealerFlag1 = this.isSaveDealer
        let dealerFlag2 = this.visit.visitConnect1 && this.visit.visitConnect1 == '其他事项' && !this.visit.visitConnect2
        let dealerFlag3 = this.visit.visitConnect1 && this.visit.visitConnect1 == '其他事项' && this.visit.visitConnect2 && this.visit.visitConnect2 == '其他事项'
        dealerFlag = !dealerFlag1 && (dealerFlag2 || dealerFlag3)
        let coopFlag = (this.visit.cooperateProbability1 && this.visit.cooperateProbability1 == '100%') || (this.visit.cooperateProbability2 && this.visit.cooperateProbability2 == '100%')
        console.log(!dealerFlag && coopFlag)
        return !dealerFlag && coopFlag
      }


    },

    // sowShowValue: {
    //   get: function () {
    //     return this.dealer.sowValue * 100
    //   }
    // },
    boschOvenSaleCapacityCompute: {
      get: function () {
        var { ovenSaleCapacity, sowShowValue } = this.dealerData;
        if (ovenSaleCapacity && sowShowValue && ovenSaleCapacity != 0) {
          return (
            Math.round((sowShowValue / 100) * ovenSaleCapacity)
          );
        } else {
          return 0;
        }
      },
      // set:function(val){
      //   this.dealer.sowValue = val/100;
      // }
    },
    visit_boschOvenSaleCapacityCompute: {
      get: function () {
        var { ovenSaleCapacity, sowShowValue } = this.visitData;
        if (ovenSaleCapacity && sowShowValue && ovenSaleCapacity != 0) {
          return (
            Math.round((sowShowValue / 100) * ovenSaleCapacity)
          );
        } else {
          return 0;
        }
      },
    },
  },

  data: () => ({
    isSaveDealer: true,
    isPerfect: true,
    isSubmit: false,
    comment: false,
    loading: false,
    dialog: false,
    dialog2: false,
    valid: false,
    pickDate: false,
    message: {
      show: false,
      type: "success",
      text: "",
    },
    visitId: null,
    visit: {
      dealerId: null,
      dealerName: null,
      goal: null,
      highlight: null,
      questionPoint: null,
      ventilationState: null,
      hotPumpState: null,
      resultPlusPlan: null,
      visitDate: null,
      dealerType: null,
      dealerContacts: null,
      dealerPosition: null,
      cooperateProbability: null,
      remark: null,
      user: null,
      dealerTypeShow: null,
      visitConnect: null,
      visitConnectShow: null,
      ovenSaleCapacity: null,
      sowValue: null,
      sowShowValue: null,
      dealerVolume: null,
      dealerYoy: null,

      dealerContacts1: null,
      cooperateProbability1: null,
      ovenSaleCapacity1: null,
      dealerContacts2: null,
      cooperateProbability2: null,
      ovenSaleCapacity2: null,
      decorationCompany1: null,
      decorationCompany2: null,
      visitConnect1: null,
      visitConnect2: null,
      // 拜访类型及对象
      visitType: null,
      // 客户联系方式
      customerContactInfo: null,
      // 潜在壁挂炉销售潜力（台/年）
      potentialSalesPotential: null,
      // 拜访内容（主要交流内容及市场情况反馈）
      visitContent: null,
      // 竞品信息反馈
      competitiveProductInfoFeedback: null,
    },
    visitData: {
      sowShowValue: 0,
      ovenSaleCapacity: 0,
    },
    dealerData: {
      sowShowValue: null,
      ovenSaleCapacity: null,
    },

    dealer: {
      ovenSaleCapacity: null,
      sowValue: null,
      sowShowValue: null,
      name: null,
      id: null,
      majorSaleChannelIds: null,
      code: null,
      developmentStateId: null,
      majorSaleChannelIdsShow: null,
    },
    dealerName: null,

    hzzt: [],
    mdlx: [],
    dealers: [],
    newComment: null,
    commentList: [],
    dealerPositionList: [
      {
        id: '法人',
        name: "法人",
      },
      {
        id: '董事长',
        name: "董事长",
      },
      {
        id: '总经理/老板',
        name: "总经理/老板",
      },
      {
        id: '副总/操盘手',
        name: "副总/操盘手",
      },
      {
        id: '销售总监',
        name: "销售总监",
      },
      {
        id: '销售经理/渠道经理',
        name: "销售经理/渠道经理",
      },
      {
        id: '店长',
        name: "店长",
      },
      {
        id: '店员',
        name: "店员",
      },
      {
        id: '其他',
        name: "其他",
      },
    ],
    dealerTypeList: [],
    visitConnectList: [
      {
        id: '建材市场店',
        name: "建材市场店",
      },
      {
        id: '社区店',
        name: "社区店",
      },
      {
        id: '装饰公司',
        name: "装饰公司",
      },
      {
        id: '设计师',
        name: "设计师",
      },
      {
        id: '家博会',
        name: "家博会",
      },
      {
        id: '小区团购',
        name: "小区团购",
      },
      {
        id: '物业精装包',
        name: "物业精装包",
      },
      {
        id: '小区团购',
        name: "小区团购",
      },
      {
        id: '安装服务工/背包客',
        name: "安装服务工/背包客",
      },
      {
        id: '燃气公司',
        name: "燃气公司",
      },
      {
        id: '老用户复购',
        name: "老用户复购",
      },
      {
        id: '老用户介绍',
        name: "老用户介绍",
      },
      {
        id: '苏宁/天猫/京东线下店',
        name: "苏宁/天猫/京东线下店",
      },
      {
        id: '线上信息转换成交',
        name: "线上信息转换成交",
      },
      {
        id: '其他事项',
        name: "其他事项",
      },
    ],
    // 拜访类型及对象下拉列表
    visitTypeList: [
      {
        id: '博世一级批发商',
        name: "博世一级批发商",
      },
      {
        id: '博世一级零售商',
        name: "博世一级零售商",
      },
      {
        id: '博世三方零售商',
        name: "博世三方零售商",
      },
      {
        id: '竞品/潜在零售商',
        name: "竞品/潜在零售商",
      },
      {
        id: '渠道（装修公司等渠道甲方人员）',
        name: "渠道（装修公司等渠道甲方人员）",
      },
      {
        id: '博世门店拜访',
        name: "博世门店拜访",
      },
      {
        id: '培训/会议',
        name: "培训/会议",
      },
      {
        id: '其他',
        name: "其他",
      },
    ],
    cooperateProbabilityList: [
      {
        id: '0%',
        name: "0%",
      },
      {
        id: '30%',
        name: "30%",
      },
      {
        id: '50%',
        name: "50%",
      },
      {
        id: '80%',
        name: "80%",
      },
      {
        id: '100%',
        name: "100%",
      },
      {
        id: '取消合作',
        name: "取消合作",
      },
    ],
    showVisitConnect: 0,
    rules: [
      value => {
        if (value === null || value === '') {
          return 'Number is required'
        }
        if (/^(-)?([1-9]\d?|100)$/.test(value)) {
          return true
        }
        return '-100 to 100 is required'
      },
    ],
  }),
  beforeRouteEnter(to, from, next) {
    let nextFunction = async (vm) => {
      await vm.getCategroy();
      if (to.params.id != 0) {
        await vm.getVisitInfo(to.params.id);
      } else {
        await vm.getDisOption();
      }

    };
    next(nextFunction);
  },
  mounted: function () {
    this.visitId = this.$route.query.visitId;
    let scope = this;
    this.$nextTick(function () {
      if (scope.visitId) {
        const data = {
          visitRecordId: scope.visitId,
        };
        api.visit.addVisitRead(data);
      }
    });
    this.dealerName = this.$route.query.dealerName
    if (this.dealerName) {
      this.visit.dealerName = this.dealerName
      this.dealerNameChangeNew(this.dealerName)
    }
    // else if (this.visit.dealerName) {
    //   this.dealerNameChange(this.visit.dealerName)
    // }
  },
  methods: {
    //添加删除拜访渠道
    changConnect() {
      if (this.showVisitConnect == 1) {
        this.showVisitConnect = 0
      } else {
        this.showVisitConnect = 1
      }
    },
    //客户类型多选更改事件
    handleSelectChange() {
      console.log('Selected items:', this.dealer.majorSaleChannelIdsShow);
      if (this.dealer.majorSaleChannelIdsShow.length < 1) {
        this.dealer.majorSaleChannelIdsShow = null
      }
      if (this.dealer.majorSaleChannelIdsShow.length > 3) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "客户类型最多选中三个"
        }, 100);
        this.dealer.majorSaleChannelIdsShow = this.dealer.majorSaleChannelIdsShow.slice(0, 3)
        this.loading = false;
      }
    },
    async getCategroy() {
      api.common.getAllCategory().then((res) => {
        const { data, status } = res.data;
        if (data && status == 200) {
          this.mdlx = data.list.filter((i) => i.categoryType == "mdlx");
          this.dealerTypeList = data.list.filter((i) => i.categoryType == "xsqd").sort(function (a, b) {
            return (a.sort > b.sort ? 1 : -1)
          });
          this.hzzt = data.list.filter((i) => i.categoryType == "hzzt").sort(function (a, b) {
            return (a.sort > b.sort ? 1 : -1)
          });
          this.visitConnectList = data.list.filter((i) => i.categoryType == "xsqd").sort(function(a, b){
            return (a.sort > b.sort ? 1 : -1)
          });
          this.visitConnectList.push({"id": "其他事项", "name": "其他事项"})

        }
      });
    },
    //沟通渠道1更改事件
    connect1Change(val) {
      this.visit.visitConnect1 = val
      console.log('当前选中渠道1：' + val)
      api.visit
        .getRecentlyContacts(
          `/visit/getRecentlyContacts?visitConnect1=${this.visit.visitConnect1}&salesId=${this.$route.query.salesId || this.user.userId}&dealerId=${this.dealer.id}`
        )
        .then((res) => {
          const { data, status } = res?.data || {};
          console.log(data);
          if (status == 0 && data) {
            this.visit.cooperateProbability1 = data[4] || ''
            this.visit.ovenSaleCapacity1 = data[5] || ''
            this.visit.decorationCompany1 = data[9] || ''
          } else {
            this.visit.cooperateProbability1 = ''
            this.visit.ovenSaleCapacity1 = ''
            this.visit.decorationCompany1 = ''
          }
        })
        .catch(() => {
          this.message = {
            show: true,
            type: "error",
            text: "数据加载失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.message.show = false;
          }, 1000);
        });
    },
    //沟通渠道2更改事件
    connect2Change(val) {
      console.log('当前选中渠道2：' + val)
      this.visit.visitConnect2 = val
      api.visit
        .getRecentlyContacts(
          `/visit/getRecentlyContacts?visitConnect2=${this.visit.visitConnect2}&salesId=${this.$route.query.salesId || this.user.userId}&dealerId=${this.dealer.id}`
        )
        .then((res) => {
          const { data, status } = res?.data || {};
          console.log(data);
          if (status == 0 && data) {
            this.visit.cooperateProbability2 = data[6] || ''
            this.visit.ovenSaleCapacity2 = data[7] || ''
            this.visit.decorationCompany2 = data[10] || ''
          } else {
            this.visit.cooperateProbability2 = ''
            this.visit.ovenSaleCapacity2 = ''
            this.visit.decorationCompany2 = ''
          }
        })
        .catch(() => {
          this.message = {
            show: true,
            type: "error",
            text: "数据加载失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.message.show = false;
          }, 1000);
        });
    },
    dealerNameChangeNew(val) {
      if(val) {
        let obj = {}
        this.dealers.forEach((item) => {
          if (item.name == val) {
            obj = item
          }
        })
        if(obj.name) {
          this.visit.dealerContacts = obj.contactPerson
          this.visit.customerContactInfo = obj.tel
          this.visit.dealerPosition = obj.position
        }
      }
    },
    //客户名称更改事件
    // dealerNameChange(val) {
    //   api.visit.getDealerByName(val)
    //     .then((res) => {
    //
    //       // this.dealer = {
    //       //     ...res.data,
    //       //   };
    //       this.dealer = res.data.data;
    //       if (this.dealer.sowValue) {
    //         this.dealerData.sowShowValue = (this.dealer.sowValue * 100).toFixed(0)
    //       } else {
    //         this.dealerData.sowShowValue = 0
    //       }
    //       if (this.dealer.ovenSaleCapacity) {
    //         this.dealerData.ovenSaleCapacity = this.dealer.ovenSaleCapacity
    //       } else {
    //         this.dealerData.ovenSaleCapacity = 0
    //       }
    //       this.isSaveDealer = true;
    //       //alert(JSON.stringify(this.dealer))
    //       if (!this.dealer.name || !this.dealer.id) {
    //         //手动输入经销商名称，并且等于其他事项，那么不保存经销商数据
    //         //这里只判断是手动输入
    //         //if (this.visit.visitConnect1 || this.visit.visitConnect1 == '其他事项') {
    //         this.isSaveDealer = false;
    //         //}
    //         // this.message = {
    //         //   show: true,
    //         //   type: "error",
    //         //   text: "客户不存在，需到客户管理新增！",
    //         // };
    //         // this.message.show = false;
    //         // setTimeout(() => {
    //         //   this.message.show = true;
    //         //   this.message.type="error"
    //         //   this.message.text="客户不存在，需到客户管理新增！"
    //         // }, 100);
    //         //this.visit.dealerName = null
    //         return
    //       } else {
    //         this.dealer.majorSaleChannelIdsShow = res.data.data?.majorSaleChannelIds?.split(",")?.map((i) => Number(i))
    //         if (this.visit.dealerContacts || this.visit.dealerPosition || this.visit.dealerVolume || this.visit.dealerYoy) {
    //           return
    //         }
    //         //获取上次拜访的联系人和职位
    //         this.visit.dealerContacts = ''
    //         this.visit.dealerPosition = ''
    //         api.visit
    //           .getRecentlyContacts(
    //             `/visit/getRecentlyContacts?salesId=${this.$route.query.salesId || this.user.userId}&dealerId=${this.dealer.id}`
    //           )
    //           .then((res) => {
    //             const { data, status } = res?.data || {};
    //             console.log(data);
    //             if (status == 0 && data) {
    //               this.visit.dealerContacts = data[0] || ''
    //               this.visit.dealerPosition = data[1] || ''
    //               //同比、台数本月带出，次月1号清空
    //               const backendDate = new Date(data[8])//数据格式为："2023-03-30"
    //               const frontendDate = new Date(this.currentDate);
    //               const month = backendDate.getMonth() + 1;
    //               if (frontendDate.getMonth() + 1 === month) {
    //                 console.log('日期在当前月份中');
    //                 this.visit.dealerVolume = data[2] || ''
    //                 this.visit.dealerYoy = data[3] || ''
    //               } else {
    //                 this.visit.dealerVolume = 0
    //                 this.visit.dealerYoy = 0
    //               }
    //
    //               // this.items = data.map((item) => {
    //               //   return {
    //               //     ...item,
    //               //     majorSaleChannel,
    //               //   };
    //               // });
    //             }
    //           })
    //           .catch(() => {
    //             this.message = {
    //               show: true,
    //               type: "error",
    //               text: "数据加载失败，请重试！",
    //             };
    //           })
    //           .finally(() => {
    //             this.loading = false;
    //             setTimeout(() => {
    //               this.message.show = false;
    //             }, 1000);
    //           });
    //       }
    //     })
    // },
    openComment() {
      this.comment = true;
      api.visit
        .getVisitComment({
          visitId: this.visit.id,
          dealerId: Number(this.visit.dealerId),
        })
        .then((res) => {
          const { data, status } = res.data;
          if (data && status == 200) {
            this.commentList = data.list.map((i) => {
              return {
                ...i,
                createTime: moment(i.createTime).format("yyyy-MM-DD"),
              };
            });
          } else {
            this.commentList = [];
          }
        })
        .catch(() => {
          this.message = {
            show: true,
            type: "error",
            text: "评论记录加载失败，请重试！",
          };
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        });
    },
    saveComment() {
      this.loading = true;
      const data = {
        visitId: this.visit.id,
        feedBackText: this.newComment,
        dealerId: Number(this.visit.dealerId),
      };
      api.visit
        .addVisitComment(data)
        .then((res) => {
          if (res.data.status == 0) {
            this.message = {
              show: true,
              type: "success",
              text: "保存成功！",
            };
            this.comment = false;
            this.newComment = null;
          } else {
            this.message = {
              show: true,
              type: "error",
              text: "保存失败，请重试！",
            };
          }
        })
        .catch(() => {
          this.message = {
            show: true,
            type: "error",
            text: "保存失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        });
    },
    getVisitInfo(id) {
      this.visitId = id;
      this.loading = true;
      api.visit
        .getVisitWithId({ id })
        .then((res) => {
          if (res.data.data) {
            this.visit = {
              ...res.data.data,
            };
            if (res.data.data.visitConnect2) {
              this.showVisitConnect = 1
            }
            this.dealerNameChangeNew(this.visit.dealerName)
            if (res.data.data.dealer) {
              this.dealer = res.data.data.dealer
              this.dealer.sowValue = res.data.data?.dealer == null ? null : res.data.data.dealer?.sowValue
              this.dealer.id = res.data.data?.dealer == null ? null : res.data.data.dealer?.id
              this.dealer.name = res.data.data?.dealer == null ? null : res.data.data.dealer?.name
              this.dealer.majorSaleChannelIdsShow = res.data.data?.dealer == null ? null : res.data.data?.dealer?.majorSaleChannelIds?.split(",")?.map((i) => Number(i))
              this.dealer.code = res.data.data?.dealer == null ? null : res.data.data?.dealer.code
              this.dealer.developmentStateId = res.data.data?.dealer == null ? null : res.data.data?.dealer.developmentStateId
            }
            this.dealerData.ovenSaleCapacity = res.data.data?.dealer == null ? 0 : res.data.data.dealer?.ovenSaleCapacity
            this.dealerData.sowShowValue = res.data.data?.dealer == null ? 0 : (res.data.data.dealer?.sowValue * 100).toFixed(0)

            // this.visitData.sowShowValue = (res.data.data.sowValue * 100).toFixed(0)
            // this.visit.visitConnectShow = res.data.data?.visitConnect == null ? null : res.data.data?.visitConnect.split(",")?.map((i) => i)
            // this.visitData.ovenSaleCapacity = res.data.data.ovenSaleCapacity
          }
        })
        .catch((err) => {
          console.log(err);
          this.message = {
            show: true,
            type: "error",
            text: "数据加载失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        });
    },
    async getDisOption() {
      api.dealer.getDealerList(`/customer-visit/get-avail-customer-list`).then((res) => {
        const { data, status } = res.data;
        if (status == 200 && data) {
          this.dealers = data?.map((item) => {
            return {
              ...item,
            };
          });
        }
      });
    },
    onDeleteVisit() {
      this.loading = true;
      api.visit
        .deleteVisit({
          id: this.visitId,
        })
        .then((res) => {
          if (res.data.status == 200) {
            this.message = {
              show: true,
              type: "success",
              text: "删除成功！",
            };
            this.$router.push({
              path: "/visiting",
            });
          } else {
            this.message = {
              show: true,
              type: "error",
              text: "删除失败，请重试！",
            };
          }
        })
        .catch(() => {
          this.message = {
            show: true,
            type: "error",
            text: "保存失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        });
    },
    onSaveVisit() {
      this.isSubmit = true
      //是暂存还是提交
      // this.$confirm("未保存和提交会丢失已填写的数据, 是否继续?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // }).then(() => {
      //   this.$router.push({
      //     path: "/distributor/detail/"+this.dealer.dealerId,
      //   });
      // });

      if (!this.checkDealerName()) {
        return false
      }
      //校验visit中的部分字段
      if (!this.checkDealerContacts()) {
        return false
      }
      if (!this.checkDealerPosition()) {
        return false
      }
      // if (!this.checkVisitConnectShow()) {
      //   return false
      // }

      //校验拜访渠道1
      if (!this.checkVisitConnect1()) {
        return false
      }
      //显示合作机率和采购潜力的时候才进行校验
      if (this.visit.visitConnect1 && this.visit.visitConnect1 != '其他事项') {
        if (this.visit.visitConnect1 == '装饰公司') {
          if (!this.checkVisitDecorationCompany1()) {
            return false
          }
        }
        //校验合作机率1
        if (!this.checkCooperateProbability1()) {
          return false
        }
        if (this.visit.cooperateProbability1 != '0%' && this.visit.cooperateProbability1 != '30%') {
          if (!this.checkVisitOvenSaleCapacity1()) {
            return false
          }
        }

      }
      //拜访渠道2显示的时候才进行校验
      if (this.showVisitConnect == 1) {
        //校验拜访渠道2
        if (!this.checkVisitConnect2()) {
          return false
        }
        //显示合作机率和采购潜力的时候才进行校验
        if (this.visit.visitConnect2 && this.visit.visitConnect2 != '其他事项') {
          if (this.visit.visitConnect2 == '装饰公司') {
            if (!this.checkVisitDecorationCompany2()) {
              return false
            }
          }
          //校验合作机率2
          if (!this.checkCooperateProbability2()) {
            return false
          }
          if (this.visit.cooperateProbability2 != '0%' && this.visit.cooperateProbability2 != '30%') {
            if (!this.checkVisitOvenSaleCapacity2()) {
              return false
            }
          }
        }
      }
      if (!this.checkGoal()) {
        return false
      }
      if (!this.checkResultPlusPlan()) {
        return false
      }
      if (!this.checkQuestionPoint()) {
        return false
      }

      //只有当它们显示的时候才进行校验
      if ((this.visit.visitConnect1 && this.visit.visitConnect1 != '其他事项'&&this.visit.visitConnect1!='竞品客户') || (this.visit.visitConnect2 && this.visit.visitConnect2 != '其他事项'&&this.visit.visitConnect2!='竞品客户') || (!this.visit.visitConnect2 && !this.visit.visitConnect1&&this.visit.visitConnect1!='竞品客户'&&this.visit.visitConnect2!='竞品客户')) {
        //校验签约总台数及客流量同比
        if (!this.checkDealerVolume()) {
          return false
        }
        if (!this.checkDealerYoy()) {
          return false
        }
      }

      // if (!this.checkCooperateProbability()) {
      //   return false
      // }
      // if (this.visit.cooperateProbability != '0%' && this.visit.cooperateProbability != '30%') {
      //   if (!this.checkVisitOvenSaleCapacity()) {
      //     return false
      //   }
      //   if (!this.checkVisitSowShowValue()) {
      //     return false
      //   }
      // }

      // if ((this.dealer.ovenSaleCapacity && this.dealer.sowValue && this.dealer.name && this.dealer.ovenSaleCapacity != 0 && this.dealer.sowValue != 0) || ((this.dealer.developmentStateId && this.dealer.developmentStateId == '22') || (this.dealer.developmentStateId && this.dealer.developmentStateId == '23'))) {
      // if((this.dealer.developmentStateId && this.dealer.developmentStateId == '22') || (this.dealer.developmentStateId && this.dealer.developmentStateId == '23')){
      if (!this.$refs.form.validate()) return;

      //判断时候需要保存经销商
      let dealerFlag = true
      let dealerFlag1 = this.isSaveDealer
      let dealerFlag2 = this.visit.visitConnect1 && this.visit.visitConnect1 == '其他事项' && !this.visit.visitConnect2
      let dealerFlag3 = this.visit.visitConnect1 && this.visit.visitConnect1 == '其他事项' && this.visit.visitConnect2 && this.visit.visitConnect2 == '其他事项'
      dealerFlag = !dealerFlag1 && (dealerFlag2 || dealerFlag3)
      //是否保存经销商数据，当为保存的时候才显示
      if (!dealerFlag) {
        //后来更改为：本次拜访渠道1或2建立合作几率等于100%时
        // if (this.dealer.developmentStateId && this.dealer.developmentStateId != '22' && this.dealer.developmentStateId != '23') {
        if ((this.visit.cooperateProbability1 && this.visit.cooperateProbability1 == '100%') || (this.visit.cooperateProbability2 && this.visit.cooperateProbability2 == '100%')) {
          //校验dealer中的字段
          if (!this.checkMajorSaleChannelIdsShow()) {
            return false
          }
          if (!this.checkDevelopmentStateId()) {
            return false
          }
          if (!this.checkDealerOvenSaleCapacity()) {
            return false
          }
          if (!this.checkDealerSowShowValue()) {
            return false
          }
          this.submitDealer('forPerfect')
          return
        } else {//不保存经销商数据，但是保存visit数据
          this.clickSubmit()
        }
        // this.submitDealer()
      } else {//不保存经销商数据，但是保存visit数据
        this.clickSubmit()
      }
    },
    clickOk() {
      this.isSubmit = false
      //校验visit中的部分字段（暂存的信息，不需要校验如下字段，若是提交则要校验更多字段。）
      // if (!this.checkCooperateProbability()) {
      //   return false
      // }
      // if (this.visit.cooperateProbability != '0%' && this.visit.cooperateProbability != '30%') {
      //   if (!this.checkVisitOvenSaleCapacity()) {
      //     return false
      //   }
      //   if (!this.checkVisitSowShowValue()) {
      //     return false
      //   }
      // }
      if (!this.checkDealerName()) {
        return false
      }
      //判断是否需要保存经销商
      let dealerFlag = true
      let dealerFlag1 = this.isSaveDealer
      let dealerFlag2 = this.visit.visitConnect1 && this.visit.visitConnect1 == '其他事项' && !this.visit.visitConnect2
      let dealerFlag3 = this.visit.visitConnect1 && this.visit.visitConnect1 == '其他事项' && this.visit.visitConnect2 && this.visit.visitConnect2 == '其他事项'
      dealerFlag = !dealerFlag1 && (dealerFlag2 || dealerFlag3)
      //是否保存经销商数据
      if (!dealerFlag) {
        //后来更改为：本次拜访渠道1或2建立合作几率等于100%时
        // if (this.dealer.developmentStateId && this.dealer.developmentStateId != '22' && this.dealer.developmentStateId != '23') {
        if ((this.visit.cooperateProbability1 && this.visit.cooperateProbability1 == '100%') || (this.visit.cooperateProbability2 && this.visit.cooperateProbability2 == '100%')) {

          //校验dealer中的字段
          if (!this.checkMajorSaleChannelIdsShow()) {
            return false
          }
          if (!this.checkDevelopmentStateId()) {
            return false
          }
          if (!this.checkDealerOvenSaleCapacity()) {
            return false
          }
          if (!this.checkDealerSowShowValue()) {
            return false
          }
          this.submitDealer("forPerfect")
          return
        } else {//不保存经销商数据，但是保存visit数据
          this.clickSubmit()
        }
        // this.submitDealer()
      } else {//不保存经销商数据，但是保存visit数据
        this.clickSubmit()
      }
    },

    //保存dealer信息
    submitDealer(val) {
      //start更新dealer信息
      this.loading = true;
      this.dealer.name = this.visit.dealerName
      this.dealer.ovenSaleCapacity = this.dealerData.ovenSaleCapacity
      this.dealer.sowShowValue = this.dealerData.sowShowValue
      if (this.dealer.sowShowValue == null || this.dealer.sowShowValue == undefined) {
        this.dealer.sowValue = 0
      } else {
        this.dealer.sowValue = (this.dealer.sowShowValue / 100).toFixed(2);
      }

      this.dealer.ovenSaleCapacity = this.dealer.ovenSaleCapacity || 0;
      this.dealer.majorSaleChannelIds = this.dealer.majorSaleChannelIdsShow?.join(",")
      if (this.dealer != null && this.dealer != undefined && this.dealer.name) {
        api.dealer
          .addDealer(this.dealer)
          .then((res) => {
            if (res.data.status == 0) {
              this.visit.dealerId = res.data.data.id
              this.dealer.id = res.data.data.id
              if (val === 'forPerfect') {
                //校验字段是否完整，若是完整则不需要弹出对话框
                const tempDealer = {
                  "tel": this.dealer.tel,
                  "addDate": this.dealer.addDate,
                  "provinceName": this.dealer.provinceName,
                  "cityName": this.dealer.cityName,
                  "districtName": this.dealer.districtName,
                  "address": this.dealer.address,
                  "majorSaleChannelIds": this.dealer.majorSaleChannelIds
                }
                let isEmpty = this.isObjectPropertiesEmpty(tempDealer, ["tel", "addDate", "provinceName", "cityName", "districtName", "address", "majorSaleChannelIds"])
                if (isEmpty) {
                  this.isPerfect = false
                  this.dialog2 = true
                  return
                } else {
                  this.isPerfect = true
                  this.clickSubmit()
                }
              } else {
                this.isPerfect = true
                this.clickSubmit()
              }
              // this.message = {
              //   show: true,
              //   type: "success",
              //   text: "保存成功！",
              // };              
            } else {
              // this.message = {
              //   show: true,
              //   type: "error",
              //   text: "保存失败，请重试！",
              // };
            }
          })
          .catch(() => {
            // this.message = {
            //   show: true,
            //   type: "error",
            //   text: "保存失败，请重试！",
            // };
          })
          .finally(() => {
            this.loading = false;
            setTimeout(() => {
              this.message.show = false;
            }, 1000);
          });
      }
      //end更新dealer
    },
    
    // 2024.05.09 更新的 保存
    newSave(val) {
      if (!this.$refs.form.validate()) return;
      this.clickSubmit(val);
    },

    // 2024.05.09 更新的 提交
    newSubmit(val) {
      this.isSubmit = true;
      if (!this.$refs.form.validate()) return;
      this.clickSubmit(val);
    },

    //保存visit信息
    clickSubmit(val) {
      this.dialog2 = false
      this.loading = true;
      if (this.showVisitConnect == 0) {
        this.visit.cooperateProbability2 = ''
        this.visit.visitConnect2 = ''
        this.visit.ovenSaleCapacity2 = ''
      }
      // this.visit.visitConnect = !this.visit.visitConnectShow ? null : this.visit.visitConnectShow?.join(",")
      // this.visit.sowValue = !this.visitData.sowShowValue ? null : (this.visitData.sowShowValue / 100).toFixed(2)
      // this.visit.ovenSaleCapacity = this.visitData.ovenSaleCapacity
      let dataTemp = {
        ...this.visit,
        visitDate: this.currentDate,
        dealerId: Number(this.visit.dealerId),
        stagingFlag: 1,//若是提交则是：0，若是暂存则是：1；若是信息不完整，那么还是：1
      };
      if (this.isSubmit) {
        dataTemp.stagingFlag = 0
      }
      if (!this.isPerfect) {
        dataTemp.stagingFlag = 1
      }
      const data = dataTemp
      // 判断是否需要执行新建接口
      let isCreateCustomerVisit = false
      this.dealers.forEach((item) => {
        if (item.name == this.visit.dealerName) {
          isCreateCustomerVisit = true
        }
      })
      if(!isCreateCustomerVisit) {
        api.visit
            .createCustomerVisit({
              name: this.visit.dealerName,
              contactPerson: this.visit.dealerContacts,
              tel: this.visit.customerContactInfo,
              position: this.visit.dealerPosition
            })
      }
      api.visit
        .addVisit(data)
        .then((res) => {
          if (res.status == 200) {
            if (val == 'zhuandao') {
              const currentPath = this.$route.path
              console.log(currentPath)
              // 修改路由路径为 /bar
              // this.$route.path = '/visiting/detail/' + JSON.parse(res.config.data).id;
              // 切换到新的路由
              if (!this.visit.id) {
                this.$router.replace('/visiting/detail/' + res.data.data.id)//JSON.parse(res.config.data).id);
              }
              this.$router.push({
                path: "/distributor/detail/" + this.dealer.id,//+"?visitId=" + res.data.data.id,
              });
            } else {
              this.message = {
                show: true,
                type: "success",
                text: "保存成功！",
              };
              this.$router.push({
                path: "/visiting",
              });
            }

          } else {
            this.message = {
              show: true,
              type: "error",
              text: "保存失败，请重试！",
            };
          }
        })
        .catch(() => {
          this.message = {
            show: true,
            type: "error",
            text: "保存失败，请重试！",
          };
        })
        .finally(() => {
          this.loading = false;
          setTimeout(() => {
            this.message.show = false;
          }, 5000);
        });
    },
    clickCancle() {
      this.clickSubmit("zhuandao")
    },
    clickConfirm() {
      this.dialog2 = false
    },

    //字段必填校验等
    checkDealerName() {
      //验证客户名称visit.dealerName
      var regex = /^[0-9]*$/;
      if (!this.visit.dealerName) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "客户名称不能为空"
        }, 100);
        this.loading = false;
        return false
      } else if (regex.test(this.visit.dealerName)) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "客户名称不能是纯数字"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    checkCooperateProbability() {
      //验证sowShowValue
      if (!this.visit.cooperateProbability) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "建立合作机率不能为空"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    //验证合作机率1
    checkCooperateProbability1() {
      //验证sowShowValue
      if (!this.visit.cooperateProbability1) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "建立合作机率1不能为空"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    //验证合作机率2
    checkCooperateProbability2() {
      //验证sowShowValue
      if (!this.visit.cooperateProbability2) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "建立合作机率2不能为空"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    checkVisitOvenSaleCapacity() {
      //验证ovenSaleCapacity
      if (!this.visitData.ovenSaleCapacity) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "全年12个月所有品牌壁挂炉采购潜力(台)不能为空"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    //验证采购潜力1
    checkVisitOvenSaleCapacity1() {
      //验证ovenSaleCapacity
      if ((!this.visit.ovenSaleCapacity1 || this.visit.ovenSaleCapacity1=='') && this.visit.visitConnect1!='竞品客户') {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "预计全年博世壁挂炉采购潜力1(台)不能为空"
        }, 100);
        this.loading = false;
        return false
      }else if((!this.visit.ovenSaleCapacity1 || this.visit.ovenSaleCapacity1=='') && this.visit.visitConnect1=='竞品客户'){
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "预计全年壁挂炉采购潜力1(台)不能为空"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    //验证采购潜力2
    checkVisitOvenSaleCapacity2() {
      //验证ovenSaleCapacity
      if ((!this.visit.ovenSaleCapacity2 || this.visit.ovenSaleCapacity2=='') && this.visit.visitConnect1!='竞品客户') {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "预计全年博世壁挂炉采购潜力2(台)不能为空"
        }, 100);
        this.loading = false;
        return false
      }else if ((!this.visit.ovenSaleCapacity2 || this.visit.ovenSaleCapacity2=='') && this.visit.visitConnect1=='竞品客户') {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "预计全年壁挂炉采购潜力2(台)不能为空"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    checkVisitSowShowValue() {
      //验证sowShowValue
      if (!this.visitData.sowShowValue) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "博世壁挂炉钱包份额不能为空"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    checkMajorSaleChannelIdsShow() {
      //验证客户类型
      if (!this.dealer.majorSaleChannelIdsShow) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "客户类型不能为空"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    checkDevelopmentStateId() {
      //验证客户建立合作机率
      if (!this.dealer.developmentStateId) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "客户建立合作机率不能为空"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    checkDealerOvenSaleCapacity() {
      //验证ovenSaleCapacity
      if (this.dealerData.ovenSaleCapacity < 0) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "客户全年12个月所有品牌壁挂炉采购潜力(台)为大于或等于0的数字"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    checkDealerSowShowValue() {
      //验证sowShowValue
      if (this.dealerData.sowShowValue < 0) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "客户博世壁挂炉钱包份额为大于或等于0的数字"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    //校验只能输入大于等于0的数字
    checkDealerSowShowValueOnInput(event) {
      const value = event
      this.message.show = false;
      if (!(value >= 0)) {
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "请输入大于或等于0的数字"
        }, 100);
        this.dealerData.sowShowValue = ''
      } else {
        this.dealerData.sowShowValue = value
      }
    },
    isObjectPropertiesEmpty(obj, props) {
      for (let prop of props) {
        if (typeof obj[prop] === 'undefined' || obj[prop] === null) {
          return true;
        }
      }
      return false;
    },
    //验证客户联系人
    checkDealerContacts() {
      // 正则表达式，匹配数字和特殊字符
      const regex = /^[\u4e00-\u9fa5a-z]+$/gi;
      if (!this.visit.dealerContacts) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "客户联系人不能为空"
        }, 100);
        this.loading = false;
        return false
      } else if (!regex.test(this.visit.dealerContacts)) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "客户联系人不能包含数字及特殊字符"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    //验证职位
    checkDealerPosition() {
      if (!this.visit.dealerPosition || this.visit.dealerPosition == '无') {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "职位不能为空"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },

    //验证装饰公司名称1
    checkVisitDecorationCompany1() {
      var regex = /^[0-9]*$/;
      if (!this.visit.decorationCompany1) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "装饰公司名称1不能为空"
        }, 100);
        this.loading = false;
        return false
      } else if (regex.test(this.visit.decorationCompany1)) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "装饰公司名称1不能是纯数字"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },

    //验证装饰公司名称2
    checkVisitDecorationCompany2() {
      var regex = /^[0-9]*$/;
      if (!this.visit.decorationCompany2) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "装饰公司名称2不能为空"
        }, 100);
        this.loading = false;
        return false
      } else if (regex.test(this.visit.decorationCompany2)) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "装饰公司名称2不能是纯数字"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },

    //验证本次拜访主要沟通渠道
    checkVisitConnectShow() {
      if (!this.visit.visitConnectShow) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "本次拜访主要沟通渠道不能为空"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    //验证本次拜访主要沟通渠道1
    checkVisitConnect1() {
      if (!this.visit.visitConnect1) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "本次拜访主要沟通渠道1不能为空"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    //验证本次拜访主要沟通渠道2
    checkVisitConnect2() {
      if (!this.visit.visitConnect2) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "本次拜访主要沟通渠道2不能为空"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    //验证拜访目的
    checkGoal() {
      var regex = /^[0-9]*$/;
      if (!this.visit.goal) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "拜访目的不能为空"
        }, 100);
        this.loading = false;
        return false
      } else if (regex.test(this.visit.goal)) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "拜访目的不能是纯数字"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    //验证拜访结果
    checkResultPlusPlan() {
      var regex = /^[0-9]*$/;
      if (!this.visit.resultPlusPlan) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "拜访结果不能为空"
        }, 100);
        this.loading = false;
        return false
      } else if (regex.test(this.visit.resultPlusPlan)) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "拜访结果不能是纯数字"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    //验证待处理问题
    checkQuestionPoint() {
      var regex = /^[0-9]*$/;
      if (!this.visit.questionPoint) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "待处理问题不能为空"
        }, 100);
        this.loading = false;
        return false
      } else if (regex.test(this.visit.questionPoint)) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "待处理问题不能是纯数字"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    //验证客户上个月博世壁挂炉签约总台数
    checkDealerVolume() {
      if (!this.visit.dealerVolume || this.visit.dealerVolume < 0) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "客户上个月博世壁挂炉签约总台数为大于或等于0的数字"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    //验证客户上个月博世壁挂炉签约总台数---校验只能输入大于等于0的数字
    checkDealerVolumeOnInput(event) {
      const value = event
      this.message.show = false;
      if (value < 0) {
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "请输入大于或等于0的数字"
        }, 100);
        this.visit.dealerVolume = ''
      } else {
        this.visit.dealerVolume = value
      }
    },
    // 校验 潜在客户壁挂炉销售潜力（台/年） --校验只能输入大于等于0的数字
    checkPotentialSalesPotentialOnInput(event) {
      const value = event
      this.message.show = false;
      if (value < 0) {
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "请输入大于或等于0的数字"
        }, 100);
        this.visit.potentialSalesPotential = ''
      } else {
        this.visit.potentialSalesPotential = value
      }
    },
    //验证近两个月全渠道客流量同比
    checkDealerYoy() {
      if (!this.visit.dealerYoy) {
        this.message.show = false;
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "近两个月全渠道客流量同比不能为空"
        }, 100);
        this.loading = false;
        return false
      }
      return true
    },
    //校验只能输入-100到100的数字dealerYoy
    onInput(event) {
      const value = event
      this.message.show = false;
      if (!/^(-)?([1-9]\d?|100)?$/.test(value)) {
        setTimeout(() => {
          this.message.show = true;
          this.message.type = "error"
          this.message.text = "请输入-100到100的数字"
        }, 100);
        this.visit.dealerYoy = ''
      } else {
        this.visit.dealerYoy = value
      }
    },
  },
};
</script>

<style lang="sass">
#visitingDetail
  height: calc(100% - 48px)
  width: 100%
  #detailForm
    width: 100%
    height: calc(100% - 40px)
    overflow: auto
.commentContainer
  max-height: 400px
  overflow: auto
</style>
